import * as Yup from "yup";

import { PaymentFrequency } from "@/features/common/enums";
import { isPaymentFrequencyConfigurable } from "@/utils";

export const PaymentFrequencyValidation = () =>
  Yup.string()
    .oneOf(Object.values(PaymentFrequency))
    .required("Payment frequency is required")
    .default(PaymentFrequency.MONTHLY)
    .test(
      "payment-frequency-requires-bullet",
      "Payment frequency other than 'Monthly' requires an amortisation type of 'Bullet loan' or 'Building credit'",
      function (value) {
        return (
          value === PaymentFrequency.MONTHLY ||
          isPaymentFrequencyConfigurable(this.parent.amortizationMethod)
        );
      },
    );
